import { h } from 'vue'
import type { IconSet, IconProps } from 'vuetify'
const requireComponent = require.context('./icons', true, /Icon[A-Z]\w+\.vue$/)

const customSvgNameToComponent: any = {}

requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName)
    const componentName = fileName
        .replace(/^\.\/(.*)\.\w+$/, '$1')
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .toLowerCase()
    customSvgNameToComponent[componentName] = componentConfig.default || componentConfig
})

const customIcons: IconSet = {
    component: (props: IconProps) =>
        h(props.tag, [h(customSvgNameToComponent[props.icon as string], { class: 'v-icon__svg' })]),
}

export { customIcons }
